// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  background: var(--cinza-1, #FBFBFB);
  width: 100%;
  height: 100vh;
}

.home-content-user {
  padding-top: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 1024px) {
  .home-content-user {
    padding-top: 104px;
  }
}
.home-content-user p {
  font-family: Montserrat;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #AE0F0A;
}
.home-content-user .home-container-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 144px;
  height: 144px;
  background-color: #F6F6F6;
  border-radius: 15px;
}

.home-content-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home-content-text h4 {
  font-family: Montserrat;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 40px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  padding-left: 56px;
  padding-right: 56px;
}
.home-content-text span {
  font-family: Montserrat;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #666666;
  padding-left: 56px;
  padding-right: 56px;
}

.home-content-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.line {
  width: 80%;
  border-bottom: 2px solid #BDBCBC;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/home-dashboard/home-dashboard/home-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACI,mCAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAEI;EAPJ;IAQQ,kBAAA;EACN;AACF;AACI;EACI,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AACR;AAII;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAHR;;AASA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;AAPJ;AASI;EACI,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAPR;AAWI;EACI,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AATR;;AAgBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAbJ;;AAgBA;EACI,UAAA;EACA,gCAAA;AAbJ","sourcesContent":[".home-container {\n    background: var(--cinza-1, #FBFBFB);\n    width: 100%;\n    height: 100vh;\n}\n\n.home-content-user {\n    padding-top: 56px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n\n    @media (max-width: 1024px) {\n        padding-top: 104px;\n    }\n\n    p {\n        font-family: Montserrat;\n        font-weight: 600;\n        font-style: SemiBold;\n        font-size: 24px;\n        leading-trim: NONE;\n        line-height: 100%;\n        letter-spacing: 0%;\n        text-align: center;\n        vertical-align: middle;\n        color: #AE0F0A;\n\n\n    }\n\n    .home-container-image {\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 144px;\n        height: 144px;\n        background-color: #F6F6F6;\n        border-radius: 15px;\n\n    }\n\n}\n\n.home-content-text {\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    h4 {\n        font-family: Montserrat;\n        font-weight: 600;\n        font-style: SemiBold;\n        font-size: 40px;\n        leading-trim: NONE;\n        line-height: 100%;\n        letter-spacing: 0%;\n        text-align: center;\n        vertical-align: middle;\n        padding-left: 56px;\n        padding-right: 56px;\n\n    }\n\n    span {\n        font-family: Montserrat;\n        font-weight: 600;\n        font-style: SemiBold;\n        font-size: 24px;\n        leading-trim: NONE;\n        line-height: 100%;\n        letter-spacing: 0%;\n        text-align: center;\n        vertical-align: middle;\n        color: #666666;\n        padding-left: 56px;\n        padding-right: 56px;\n\n\n    }\n}\n\n\n.home-content-flex {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.line {\n    width: 80%;\n    border-bottom: 2px solid #BDBCBC\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
